"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBackDefault = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CashBackIcon = require("./components/CashBackIcon");
var _SuperCashBack = _interopRequireDefault(require("./SuperCashBack"));
var _AvatarIcon = _interopRequireDefault(require("../AvatarIcon"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CashBackDefault = exports.CashBackDefault = function CashBackDefault(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    isSuper = _ref.isSuper,
    label = _ref.label,
    cashbackText = _ref.cashbackText,
    isColumnLayout = _ref.isColumnLayout,
    count = _ref.count,
    avatarPath = _ref.avatarPath,
    withBorder = _ref.withBorder,
    className = _ref.className,
    customCashbackIconURL = _ref.customCashbackIconURL,
    customCashbackText = _ref.customCashbackText;
  var classNames = [className, isColumnLayout && isSuper && 'column', isSuper && !customCashbackIconURL && 'super-cashback'].filter(Boolean).join(' ');
  var Icon = (0, _react.useMemo)(function () {
    if (customCashbackIconURL) {
      var CustomIcon = function CustomIcon() {
        return /*#__PURE__*/_react["default"].createElement(_styles.CashBackCustomIcon, {
          alt: "cashback icon",
          src: customCashbackIconURL
        });
      };
      CustomIcon.displayName = 'CustomIcon';
      return CustomIcon;
    }
    return isSuper ? _SuperCashBack["default"] : _CashBackIcon.CashBackIcon;
  }, [isSuper, customCashbackIconURL]);
  return /*#__PURE__*/_react["default"].createElement(_styles.CashBackContainer, {
    size: size,
    withAvatar: !!avatarPath,
    className: classNames,
    withBorder: !!withBorder
  }, cashbackText && /*#__PURE__*/_react["default"].createElement(_styles.CashBackLabel, null, customCashbackText || label), /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, null, /*#__PURE__*/_react["default"].createElement(_styles.CashBackAmount, null, count), /*#__PURE__*/_react["default"].createElement(_styles.CashBackIconLayout, null, /*#__PURE__*/_react["default"].createElement(Icon, null))), avatarPath && /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
    avatarUrl: avatarPath,
    size: 20
  }));
};
var StyledAvatar = (0, _styledComponents["default"])(_AvatarIcon["default"]).withConfig({
  displayName: "CashBackDefault__StyledAvatar",
  componentId: "sc-bo9ri9-0"
})(["margin:4px 4px 4px 6px;"]);